import { flow, head, parseInt, split } from "lodash/fp";
import {
  formatDistanceToNowStrict,
  isPast,
  isValid,
  parseISO,
  format,
} from "date-fns";
import type { Result } from "storefront/lib/Result";
import { failure, success } from "storefront/lib/Result";
import extract from "storefront/lib/Result/extract";
// empty ISO date string
export const emptyTimestamp = new Date().toISOString();
// takes an ISO formatted dateString and tries to convert it to a Date
export const fromString = (
  str: string | null | undefined,
): Result<Error, Date> => {
  if (typeof str === "string" && isValid(parseISO(str))) {
    return success(parseISO(str));
  }

  return failure(
    new Error(
      `Cannot parse a date from ${
        typeof str === "string" ? `"${str}"` : "null or undefined"
      }`,
    ),
  );
};
export const extractDateFromString = (
  dateString: string | null | undefined,
): Date | null | undefined =>
  extract<Error, Date, Date | undefined>(
    (error) => {
      // eslint-disable-next-line no-console
      console.warn(error.message);
      return undefined;
    },
    (date) => date,
  )(fromString(dateString));
export const minutesUntil = (date: Date): number => {
  if (isPast(date)) return 0;
  const minutes = flow([
    (d) =>
      formatDistanceToNowStrict(d, {
        unit: "minute",
      }),
    split(" "),
    head,
    parseInt(10),
  ])(date);
  return minutes;
};
export const formatDateString = (
  dateString: string | null | undefined,
  dateFormat: string,
  defaultValue = "",
): string => {
  const parsedDate = extractDateFromString(dateString);

  if (parsedDate) {
    return format(parsedDate, dateFormat);
  }

  return defaultValue;
};
